const endpoint = "https://niub.cuba-games.com"
const cpoint = "https://central-backend.cuba-lv.com"

const startpoint = `${cpoint}/`
const mediapoint = `${cpoint}`

const gamePlace = { studio: "bishkek", room: "table7-room" } // tbilisi, bishkek

export { endpoint, mediapoint, startpoint, gamePlace } 

